"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTT001_Regist = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const common_1 = require("../../../common");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const server_1 = require("../../../server");
const functions_1 = require("../../../server/functions");
const layout_1 = require("../../base/layout");
const DSTT001_Regist_Child_1 = require("./component/DSTT001_Regist_Child");
const SettingTable_1 = require("./component/DSTT001_Regist_Child/SettingTable");
const DSTTStyled_1 = require("./DSTTStyled");
const CopyToClipboard_1 = require("../../../common/element/CopyToClipboard");
exports.DSTT001_Regist = react_1.default.memo(({ isDetail = false, isModify = false, isPrevious = false, isTeacher, id, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { classesId } = (0, GlobalStateProvider_1.useGlobalState)();
    const [item, setItem] = (0, react_1.useState)();
    const [conferenceMember, setConferenceMember] = (0, react_1.useState)([]);
    const [conferenceInfoData, setConferenceInfoData] = (0, react_1.useState)({
        title: '',
        conferenceMode: 'select',
        date: (0, moment_1.default)().add(5, 'minutes').startOf('minute').format('YYYY-MM-DDTHH:mm:ssZ'),
        endDate: (0, moment_1.default)().add(65, 'minutes').startOf('minute').format('YYYY-MM-DDTHH:mm:ssZ'),
        entryDate: '10',
    });
    const [isClosed, setIsClosed] = (0, react_1.useState)(false);
    // 참여자 목록
    const [memberData, setMemberData] = (0, react_1.useState)([]);
    // 테스트 설정
    const [testSettingData, setTestSettingData] = (0, react_1.useState)([]);
    const [choiceTestSetting, setChoiceTestSetting] = (0, react_1.useState)([]);
    // 지연 생성(Deferred) 대기 테스트 payload — 신규 강의 등록 시 즉시 생성하지 않고 보관했다가
    // 강의 등록 API 성공 후 실제 생성·연동한다. 취소하면 폐기(생성 0).
    const [pendingTests, setPendingTests] = (0, react_1.useState)([]);
    // 학습 자료 설정
    const [contentData, setContentData] = (0, react_1.useState)([]);
    const [studySettingData, setStudySettingData] = (0, react_1.useState)([]);
    // SMS 자동발송
    const [isSMSCheck, setIsSMSCheck] = react_1.default.useState(false);
    const [SMSTime, setSMSTime] = react_1.default.useState(10); // 기본값 10분 전
    const [isOnlyStudentSms, setIsOnlyStudentSms] = react_1.default.useState(isDetail ? false : true); // 학생에게만 SMS 발송
    // 1:1 라이브
    const [liveMember, setLiveMember] = (0, react_1.useState)([]);
    const [isLiveCheck, setIsLiveCheck] = react_1.default.useState(false);
    // 예비 라이브
    const [isSpareLive, setIsSpareLive] = react_1.default.useState(false);
    const [spareLiveDatas, setSpareLiveDatas] = (0, react_1.useState)(undefined);
    // 라이브 테스트 알림 시간 (분)
    const [isCustomCountDown, setIsCustomCountDown] = react_1.default.useState(false);
    const [countDownSet, setCountDownSet] = (0, react_1.useState)([]);
    const [entryDatas, setEntryDatas] = (0, react_1.useState)([]);
    const [background, setBackground] = (0, react_1.useState)([]);
    const [load, setLoad] = (0, react_1.useState)(false);
    // 제외된 참여자 목록
    const [excludeMembers, setExcludeMembers] = (0, react_1.useState)([]);
    const setConferenceMutation = (0, react_query_1.useMutation)(server_1.postConferenceList);
    const updateConferenceMutation = (0, react_query_1.useMutation)(server_1.updateConferenceList);
    const connectionConferenceData = (0, react_query_1.useMutation)(server_1.connectionConferenceList);
    const deleteMutation = (0, react_query_1.useMutation)(server_1.deleteConferenceList);
    const { data, refetch } = (0, server_1.useConferenceList)({
        id,
        with_more_info: true,
    });
    const { data: entryData, refetch: entryDataRefetch } = (0, server_1.useEntryData)({
        ...(isDetail ? { id: id } : {}),
    });
    const { data: spareLiveData, refetch: refetchSpareLive } = (0, server_1.useSpareLiveStreaming)(classesId);
    (0, react_1.useEffect)(() => {
        entryDataRefetch();
    }, [isDetail]);
    (0, react_1.useEffect)(() => {
        if (!isSpareLive)
            return;
        refetchSpareLive();
    }, [isSpareLive]);
    (0, react_1.useEffect)(() => {
        if (spareLiveData) {
            setSpareLiveDatas(spareLiveData);
        }
    }, [spareLiveData]);
    (0, react_1.useEffect)(() => {
        if (!id) {
            setLoad(true);
            return;
        }
        setLoad(false);
        refetch();
    }, [id]);
    (0, react_1.useEffect)(() => {
        if (entryData) {
            const { items: entryItems } = entryData;
            setEntryDatas(entryItems);
        }
    }, [entryData]);
    (0, react_1.useEffect)(() => {
        setLoad(false);
        const handlerSettingItem = async () => {
            await APP.eventManager.publish('SHOW_LOADING', true);
            const { items } = data;
            if (items && items.length > 0) {
                const item = items[0];
                setIsClosed(item.status === 'closed'
                    ? true
                    : (0, moment_1.default)().isBetween((0, moment_1.default)(item.start_time).subtract(item.pre_entering_duration, 'minutes'), (0, moment_1.default)(item.start_time)));
                await (0, server_1.getAssignmentList)((0, functions_1.objectToQueryString)({
                    class_id: classesId,
                    conference_id: id,
                    assignment: false,
                    // survey 필터 미지정 — 출제유형 '설문조사'(survey:true) 테스트도 강의에 연결된 것으로 포함
                })).then((res) => {
                    const { items } = res.result;
                    const newItems = items.map(i => i.id);
                    setChoiceTestSetting(newItems);
                    setTestSettingData(newItems);
                });
                setItem(item);
                setConferenceInfoData({
                    title: item.title,
                    conferenceMode: item.type,
                    date: item.start_time,
                    endDate: (item.end_time && item.end_time !== '0001-01-01T00:00:00Z')
                        ? item.end_time
                        : (0, moment_1.default)(item.start_time).add(item.progress_duration, 'minutes').format('YYYY-MM-DDTHH:mm:ssZ'),
                    entryDate: item.pre_entering_duration.toString(),
                });
                setConferenceMember(item.members);
                const backId = item.background.split('/')[6];
                backId && setBackground([backId]);
                setStudySettingData(backId ? [...item.contents, backId] : [...item.contents]);
                // setLiveMember(item.qna_managers);
                setSMSTime(item.alarm_before);
                setIsSMSCheck(item.alarm_message);
                const hasAlarmMembersOnly = Object.prototype.hasOwnProperty.call(item, 'alarm_members_only');
                setIsOnlyStudentSms(hasAlarmMembersOnly ? item.alarm_members_only !== false : !isDetail);
                if (item.count_down_set && item.count_down_set.length > 0) {
                    setIsCustomCountDown(true);
                    setCountDownSet(item.count_down_set);
                }
                else {
                    setIsCustomCountDown(false);
                    setCountDownSet([]);
                }
                setIsSpareLive(item.spare_live);
                setLoad(true);
                await APP.eventManager.publish('SHOW_LOADING', false);
                return;
            }
        };
        if (data) {
            handlerSettingItem();
        }
        else {
            setConferenceInfoData({
                title: '',
                conferenceMode: 'select',
                date: (0, moment_1.default)().add(5, 'minutes').startOf('minute').format('YYYY-MM-DDTHH:mm:ssZ'),
                endDate: (0, moment_1.default)().add(65, 'minutes').startOf('minute').format('YYYY-MM-DDTHH:mm:ssZ'),
                entryDate: '10',
            });
            setConferenceMember([]);
            setStudySettingData([]);
            setLiveMember([]);
            setIsOnlyStudentSms(isDetail ? false : true);
            setLoad(true);
        }
    }, [data]);
    // 학습 자료 설정에서 강의모드 변경에 따라 필터링
    (0, react_1.useEffect)(() => {
        const testDataMap = new Map(contentData.map(i => [i.id, i.type]));
        if (conferenceInfoData?.conferenceMode !== 'mock_test') {
            studySettingData.map(item => {
                if (testDataMap.get(item) === 'background')
                    setStudySettingData(prev => prev.filter(i => i !== item));
            });
        }
        else {
            studySettingData.map(item => {
                if (testDataMap.get(item) === 'document' || testDataMap.get(item) === 'video') {
                    setStudySettingData(prev => prev.filter(i => i !== item));
                }
                ;
            });
        }
    }, [conferenceInfoData?.conferenceMode, contentData, studySettingData]);
    const previousPage = () => {
        APP.eventManager.publish('UPDATE_DETAIL_MENU', {
            menuDetail: undefined,
            id: undefined,
        });
    };
    // 취소 버튼 핸들러: 지연 생성(Deferred) 도입으로 신규 강의 등록 시 테스트는 아직 서버에 생성되지 않음.
    // → 취소하면 생성된 게 없으므로 삭제할 대상이 없고, 메모리의 pending payload 만 폐기하면 된다.
    // (상세 isDetail / 수정 isModify 는 이미 저장된 강의의 테스트라 이 화면에서 손대지 않음)
    const handlerCancel = async () => {
        if (!isDetail && !isModify && pendingTests.length > 0) {
            if (!window.confirm('등록된 테스트가 있습니다. 강의 등록을 취소하시겠습니까?')) {
                return;
            }
            // 지연 생성이므로 서버에 생성된 테스트가 없다 → pending 폐기만.
            setPendingTests([]);
        }
        previousPage();
    };
    const EditPage = () => {
        APP.eventManager.publish('UPDATE_DETAIL_MENU', {
            menuDetail: 'modify',
            id: id,
        });
    };
    const onSubmit = async () => {
        let conference_id = id;
        // 지연 생성으로 이번 onSubmit 에서 실제 생성된 테스트 id 들 (부분 실패 시 롤백 대상)
        const createdTestIds = [];
        APP.eventManager.publish('SHOW_LOADING', true);
        try {
            if (!conferenceInfoData?.title) {
                throw new Error(t('error.emptyTitle'));
            }
            // 입장이 이미 열린 강의는 저장을 막는다.
            // 리스트·상세는 입장 시작 시각(시작일시 − 입장시간)부터 '수정' 버튼을 감추지만
            // (ReservationItem 의 progressTime), 그 전에 열어둔 수정 화면에는 아무 제약이 없어
            // 학생이 입장 중인 강의의 일시·참여자·테스트 연동이 조용히 바뀔 수 있었다.
            // 판정 기준은 편집 중인 값이 아니라 '실제로 입장이 열렸는지'이므로 저장된 값(item)을 쓴다.
            // 이 검사를 아래 lateNowConference 보다 먼저 두어, 시작 시각까지 지나버린 경우에도
            // '수업일이 과거' 대신 상황에 맞는 안내가 나가도록 한다.
            if (isModify && item) {
                const enterOpenAt = (0, moment_1.default)(item.start_time).subtract(item.pre_entering_duration, 'minutes');
                if ((0, moment_1.default)().isSameOrAfter(enterOpenAt)) {
                    throw new Error(t('error.alreadyEnterableConference', { time: enterOpenAt.format('HH:mm') }));
                }
            }
            if ((0, moment_1.default)(conferenceInfoData?.date).isBefore((0, moment_1.default)())) {
                throw new Error(t('error.lateNowConference'));
            }
            // 입장시간은 숫자 입력(type=text)이라 '30분'/공백 등 파싱 불가 값이 들어올 수 있다.
            // 기존 검증은 NaN 을 통과시켜(NaN <= 0 === false) 아래 payload 의 `|| 60` 폴백으로
            // 조용히 60분이 저장됐다 → 파싱 결과를 명시적으로 검증하고 그 값을 그대로 전송한다.
            const enterMinutes = parseInt(conferenceInfoData?.entryDate, 10);
            if (!Number.isFinite(enterMinutes) || enterMinutes <= 0) {
                throw new Error(t('error.noEnterTime'));
            }
            if ((0, moment_1.default)(conferenceInfoData?.endDate).isSameOrBefore((0, moment_1.default)(conferenceInfoData?.date))) {
                throw new Error(t('error.endTimeBeforeStartTime'));
            }
            if (conferenceInfoData?.conferenceMode === 'mock_test') {
                // 신규 등록 시 테스트는 testSettingData(기존/즉시생성)와 pendingTests(지연) 둘로 나뉘므로 합산으로 검증.
                const totalTestCount = testSettingData.length + pendingTests.length;
                if (totalTestCount > 1) {
                    throw new Error(t('error.onlyOneTest'));
                }
                if (totalTestCount <= 0) {
                    throw new Error(t('error.onlyOneTest'));
                }
                if (background && background.length > 1) {
                    throw new Error(t('error.onlyOneBackground'));
                }
                if (background && background.length <= 0) {
                    throw new Error(t('error.noSelectBackground'));
                }
            }
            else {
                if (background && background.length > 0) {
                    throw new Error(t('error.noUseBackground'));
                }
            }
            const data = {
                class_id: classesId,
                // members: memberData.map(item => ({
                // 	user_id: item.id,
                // 	role_name: item.role_name,
                // })),
                spare_live: isSpareLive,
                alarm_before: SMSTime,
                alarm_message: isSMSCheck,
                alarm_members_only: isOnlyStudentSms,
                count_down_set: countDownSet,
                exclude_members: excludeMembers,
                pre_entering_duration: enterMinutes,
                end_time: conferenceInfoData?.endDate,
                // progress_duration: moment(conferenceInfoData?.endDate).diff(moment(conferenceInfoData?.date), 'minutes') || 0,
                qna_managers: liveMember,
                start_time: conferenceInfoData?.date,
                title: conferenceInfoData?.title,
                // 강의모드(type)는 등록 시에만 전송한다 — 수정 시 모드 변경 불가 정책(047e18fa).
                // (한 번 수정 시에도 전송하도록 열었다가 롤백)
                ...(!isModify
                    ? {
                        type: conferenceInfoData?.conferenceMode,
                        display_member_count: false,
                    }
                    : {}),
            };
            if (isModify) {
                await updateConferenceMutation.mutateAsync({ id, props: data });
            }
            else {
                const response = await setConferenceMutation.mutateAsync(data);
                conference_id = response.result.id;
            }
            // [지연 생성] 강의 생성/수정 성공 후, 대기 중인 테스트 payload 를 순차 생성·연동한다.
            // 순서 강제: 강의 생성 → 테스트 생성 → (기타 상세유형) → 질문 생성. (postQuestion 은 test id 필수)
            // 강의 시작/종료를 팝업 등록 후 수정했을 수 있으므로 최신 값으로 startline/deadline 을 덮어써 동기화한다.
            for (const pending of pendingTests) {
                const assignmentData = {
                    ...pending.data,
                    conference_id,
                    ...(conferenceInfoData?.date
                        ? { startline: (0, moment_1.default)(conferenceInfoData.date).format('YYYY-MM-DDTHH:mm:ssZ') }
                        : {}),
                    ...(conferenceInfoData?.endDate
                        ? { deadline: (0, moment_1.default)(conferenceInfoData.endDate).format('YYYY-MM-DDTHH:mm:ssZ') }
                        : {}),
                };
                const createRes = await (0, server_1.postAssignmentList)(assignmentData);
                const newTestId = createRes.result.id;
                createdTestIds.push(newTestId);
                // 기타(etc) 상세 유형은 선택 필수가 아니므로 실패해도 테스트 생성 자체는 유지 (try/catch 격리)
                if (pending.subTypeId) {
                    try {
                        await (0, server_1.setTestSubType)(newTestId, pending.subTypeId);
                    }
                    catch (subTypeError) {
                        console.warn('[DSTT001] setTestSubType (optional) failed:', subTypeError);
                    }
                }
                await (0, server_1.postQuestion)({ id: newTestId, props: pending.questions });
            }
            // 강의에 연동할 테스트 = 기존/즉시생성분(testSettingData) + 이번 지연 생성분(createdTestIds)
            const connectTests = [...testSettingData, ...createdTestIds];
            let updateConnectionConferencePromise;
            const filterBackground = studySettingData.filter(item => !background.includes(item));
            if ((filterBackground && filterBackground.length >= 0) ||
                (connectTests && connectTests.length >= 0)) {
                updateConnectionConferencePromise = connectionConferenceData.mutateAsync({
                    id: conference_id,
                    props: {
                        tests: connectTests,
                        contents: [...(filterBackground ? filterBackground : [])],
                        ...(conferenceInfoData?.conferenceMode === 'mock_test'
                            ? {
                                background: background && background.length > 0
                                    ? background[0]
                                    : '',
                            }
                            : {}),
                    },
                });
            }
            await Promise.all([updateConnectionConferencePromise]);
            // 연동까지 성공 → 대기 payload 는 실제 테스트로 반영되었으므로 폐기
            setPendingTests([]);
            APP.eventManager.publish('UPDATE_DETAIL_MENU', {
                menuDetail: 'list',
            });
        }
        catch (error) {
            console.error('Error during conference submission:', error);
            // [부분 실패 롤백] 이번에 실제로 생성된 테스트를 청소해 "취소하면 아무것도 안 남음" 불변식 유지.
            if (createdTestIds.length > 0) {
                try {
                    await Promise.allSettled(createdTestIds.map(testId => (0, server_1.deleteAssignmentList)(testId)));
                }
                catch (rollbackError) {
                    console.error('Failed to rollback created tests after error:', rollbackError);
                }
            }
            if (conference_id && !isModify) {
                try {
                    await deleteMutation.mutateAsync(conference_id);
                }
                catch (deleteError) {
                    console.error('Failed to delete conference after error:', deleteError);
                }
            }
            alert(error.message || error);
        }
        finally {
            APP.eventManager.publish('SHOW_LOADING', false);
        }
    };
    const { isTablet, isMobile, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    // 회의실 정보
    const renderConferenceInfo = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(DSTT001_Regist_Child_1.ConferenceInfo, { defaultItem: conferenceInfoData, setItem: setConferenceInfoData, isDetail: isDetail, isModify: isModify }));
    }, [id, conferenceInfoData, isDetail, isModify]);
    // 참여자 설정
    const renderMemberTable = (0, react_1.useMemo)(() => (react_1.default.createElement(DSTT001_Regist_Child_1.MembersTable, { isModify: isModify, isDetail: isDetail, initMember: conferenceMember, setItem: setMemberData, allChecked: !isDetail && !isModify ? true : false, entryData: entryDatas && isDetail && entryDatas, setExclude: setExcludeMembers })), [isModify, isDetail, conferenceMember, entryDatas]);
    // 테스트 자료 설정
    const renderTestSetting = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(DSTT001_Regist_Child_1.TestSettingTable, { isDetail: isDetail, isModify: isModify, conference_id: id, conferenceStart: conferenceInfoData?.date, conferenceEnd: conferenceInfoData?.endDate, item: testSettingData, choice: choiceTestSetting, setChoice: setChoiceTestSetting, setItem: setTestSettingData, 
            // 지연 생성은 신규 강의 등록에만 적용 (수정/상세는 기존 즉시 생성/조회 경로 유지)
            deferred: !isModify && !isDetail, pendingTests: pendingTests, setPendingTests: setPendingTests }));
    }, [isModify, isDetail, testSettingData, choiceTestSetting, id, conferenceInfoData?.date, conferenceInfoData?.endDate, pendingTests]);
    const renderStudySetting = (0, react_1.useMemo)(() => {
        if (!load)
            return;
        return (react_1.default.createElement(DSTT001_Regist_Child_1.StudySettingTable, { isDetail: isDetail, isModify: isModify, background: background, initItem: studySettingData, setItem: setStudySettingData, setBackground: setBackground, mode: conferenceInfoData?.conferenceMode, testData: contentData, setTestData: setContentData }));
    }, [load, conferenceInfoData?.conferenceMode, isDetail, isModify, studySettingData, setStudySettingData, setBackground, background, contentData, setContentData]);
    // 현재 탭 위치 및 이전으로 돌아가기
    const renderInfoTitle = (0, react_1.useMemo)(() => (react_1.default.createElement(layout_1.DetailTitleInfo
    // title={
    // 	isDetail
    // 		? t(`conference.${isPrevious ? 'lastClass' : 'reservation'}`)
    // 		: t('conference.reservation')
    // }
    , { 
        // title={
        // 	isDetail
        // 		? t(`conference.${isPrevious ? 'lastClass' : 'reservation'}`)
        // 		: t('conference.reservation')
        // }
        title: `${isDetail
            ? t(`conference.${isPrevious ? 'lastClass' : 'conference'}`)
            : t('conference.conference')} ${t(`common.${isDetail ? 'detail' : isModify ? 'modify' : 'regist'}`)}`, previousPage: previousPage })), [isDetail, isPrevious, isModify]);
    // SettingTable 의 카운트다운 게이팅(testData.length)에 지연 생성 대기 테스트(pending)도 포함한다.
    // ★ 참조 안정화(useMemo) 필수 — 매 렌더 새 배열을 넘기면 SettingTable 의 [testData] effect 가
    //   setCountDownSet([]) 를 반복 호출하고, 그 상태 변화가 renderSetting memo(countDownSet 의존)를
    //   재계산시켜 새 배열을 또 만드는 무한 렌더 루프("Maximum update depth exceeded")가 발생한다.
    const settingTestData = (0, react_1.useMemo)(() => [...testSettingData, ...pendingTests.map(p => p.tempId)], [testSettingData, pendingTests]);
    const renderSetting = (0, react_1.useMemo)(() => isDetail ? (react_1.default.createElement("div", { className: "setting-detail" },
        react_1.default.createElement("div", { className: "field-global-001", style: { flexDirection: 'column', alignItems: 'flex-start' } },
            react_1.default.createElement("div", { className: "task-label", style: { minWidth: isMobile ? '100px' : '110px', flex: 1 } }, t('conference.smsAutoSend')),
            react_1.default.createElement("div", { className: "fext-field setting_box" },
                item?.alarm_message && (react_1.default.createElement("div", { className: "btn-file" },
                    react_1.default.createElement("span", { className: "name overText" }, item?.alarm_before === 0 ? "" : `${item?.alarm_before}분 전`))),
                item?.alarm_message && isOnlyStudentSms && (react_1.default.createElement("div", { className: "btn-file" },
                    react_1.default.createElement("span", { className: "name overText" }, t('sendSMS.onlyStudentSend')))))),
        react_1.default.createElement("div", { className: "field-global-001", style: { flexDirection: 'column', alignItems: 'flex-start' } },
            react_1.default.createElement("div", { className: "task-label", style: { minWidth: isMobile ? '100px' : '110px', flex: 1 } }, t('conference.spareLive')),
            isSpareLive && spareLiveDatas ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(CopyToClipboard_1.CopyToClipboard, { value: spareLiveDatas.stream_key, buttonText: 'Key \uBCF5\uC0AC' }),
                react_1.default.createElement(CopyToClipboard_1.CopyToClipboard, { value: spareLiveDatas.publish_url, buttonText: 'Url \uBCF5\uC0AC' }))) : (react_1.default.createElement("div", { className: "fext-field setting_box", style: { flexDirection: 'column' } }))),
        react_1.default.createElement("div", { className: "field-global-001", style: { flexDirection: 'column', alignItems: 'flex-start' } },
            react_1.default.createElement("div", { className: "task-label", style: { minWidth: isMobile ? '100px' : '110px', flex: 1 } }, t('conference.liveQAndARoom')),
            react_1.default.createElement("div", { className: "fext-field setting_box" }, item?.qna_managers.map((member, index) => member.name &&
                member.name !== '' && (react_1.default.createElement("div", { key: index, className: "btn-file" },
                react_1.default.createElement("span", { className: "name overText" },
                    " ",
                    member.name)))))),
        react_1.default.createElement("div", { className: "field-global-001", style: { flexDirection: 'column', alignItems: 'flex-start' } },
            react_1.default.createElement("div", { className: "task-label", style: { minWidth: isMobile ? '100px' : '110px', flex: 1 } }, t('conference.liveTestAlarm')),
            react_1.default.createElement("div", { className: "fext-field setting_box" }, item?.count_down_set.map((number, index) => number && (react_1.default.createElement("div", { key: index, className: "btn-file" },
                react_1.default.createElement("span", { className: "name overText" },
                    number,
                    "\uBD84 \uC804")))))))) : (react_1.default.createElement(SettingTable_1.SettingTable, { testData: settingTestData, isCustomCountDown: isCustomCountDown, setIsCustomCountDown: setIsCustomCountDown, countDownSet: countDownSet, setCountDownSet: setCountDownSet, spareLiveDatas: spareLiveDatas, isSpareLive: isSpareLive, setIsSpareLive: setIsSpareLive, isModify: isModify, isSMSCheck: isSMSCheck, initSMSTime: SMSTime, setInitSMSTime: setSMSTime, isOnlyStudentSms: isOnlyStudentSms, setIsOnlyStudentSms: setIsOnlyStudentSms, setIsSMSCheck: setIsSMSCheck, initLiveCheck: isLiveCheck, defaultLiveMember: item?.qna_managers, initLiveMember: liveMember, setInitLiveCheck: setIsLiveCheck, setLiveMember: setLiveMember })), [
        isDetail,
        item?.qna_managers,
        item?.alarm_before,
        isOnlyStudentSms,
        liveMember,
        isLiveCheck,
        isSMSCheck,
        setSMSTime,
        SMSTime,
        isModify,
        setIsSMSCheck,
        setIsLiveCheck,
        isSpareLive,
        setIsSpareLive,
        spareLiveDatas,
        setSpareLiveDatas,
        settingTestData,
        countDownSet,
        setCountDownSet,
        isCustomCountDown,
        setIsCustomCountDown
    ]);
    // 저장 버튼 가져오기
    const renderBtnContainer = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: "btn-container", style: { marginBottom: isMobile ? '12px' : 'unset' } },
        !isClosed &&
            isTeacher &&
            item &&
            !(0, moment_1.default)().isBetween((0, moment_1.default)(item.start_time).subtract(item.pre_entering_duration, 'minutes'), (0, moment_1.default)(item.start_time).add(item.progress_duration, 'minutes')) && (react_1.default.createElement(common_1.Button, { className: "btn_white xmd", text: "common.modify", onClick: EditPage })),
        react_1.default.createElement(common_1.Button, { className: "btn_white xmd", text: "common.cancel", onClick: handlerCancel }),
        !isDetail && (react_1.default.createElement(common_1.Button, { className: "btn_default xmd", text: "common.okay", onClick: onSubmit })))), [
        isClosed,
        isTeacher,
        isDetail,
        id,
        conferenceInfoData,
        liveMember,
        studySettingData,
        testSettingData,
        pendingTests,
        background,
        isSMSCheck,
        isOnlyStudentSms,
        SMSTime,
        isLiveCheck,
        isModify,
        countDownSet,
        isSpareLive,
    ]);
    if (isTablet || isMobile) {
        const tabList = [
            {
                id: 1,
                title: '기본정보',
                component: (react_1.default.createElement(react_1.default.Fragment, null,
                    renderConferenceInfo,
                    isDetail && renderSetting)),
                styles: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: isTablet ? '24px' : '12px',
                },
            },
            {
                id: 2,
                title: '참여자',
                component: renderMemberTable,
            },
            {
                id: 3,
                title: '테스트',
                component: renderTestSetting,
            },
            {
                id: 4,
                title: '학습자료',
                component: renderStudySetting,
            },
        ];
        if (!isDetail) {
            tabList.push({
                id: 5,
                title: '설정',
                component: (react_1.default.createElement(react_1.default.Fragment, null, renderSetting)),
                styles: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    height: '100%',
                },
            });
        }
        return (react_1.default.createElement(DSTTStyled_1.LiveReservationStyled, { "$isTablet": isTablet, "$isMobile": isMobile },
            react_1.default.createElement(layout_1.MobileTabLayout, { isTabMode: true, tabList: tabList, showNav: false, showPageButton: !isPrevious, showPageTab: true, submitAssignment: isDetail ? previousPage : onSubmit })));
    }
    return (react_1.default.createElement(DSTTStyled_1.LiveReservationStyled, { "$isTablet": isTablet, "$isMobile": isMobile, className: "dstt001_regist wrapper-padding" },
        renderInfoTitle,
        react_1.default.createElement("div", { className: "container-wrapper" },
            react_1.default.createElement("div", { className: "container-001" }, renderConferenceInfo),
            react_1.default.createElement("div", { className: "container-002" },
                renderMemberTable,
                react_1.default.createElement("div", { className: "setting-wrap" },
                    react_1.default.createElement("div", { className: "setting-list" },
                        renderTestSetting,
                        renderStudySetting),
                    renderSetting))),
        renderBtnContainer));
});
